export const ROLES = {
  PRO: 'pro',
  HO: 'ho',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIRM_USER: 'ROLE_FIRM_USER',
}
